// extracted by mini-css-extract-plugin
export default {"Home":"home_Home__H+WIT","HomeCards":"home_HomeCards__7WbcL"};